var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconoCerrarSesion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_13165",
    "data-name": "Grupo 13165",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.022,
    height: 17.484,
    viewBox: "0 0 16.022 17.484",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_30978",
    "data-name": "Trazado 30978",
    d: "M326.1,403.466h0a.742.742,0,0,0,.457.674,6.592,6.592,0,1,1-9.195,5.989h0a6.554,6.554,0,0,1,3.91-5.988.744.744,0,0,0,.458-.676h0a.728.728,0,0,0-.727-.729.743.743,0,0,0-.274.052,8.008,8.008,0,1,0,6.372,0,.728.728,0,0,0-1,.677Z",
    transform: "translate(-315.91 -400.664)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_30979",
    "data-name": "Trazado 30979",
    d: "M326.346,399.974h0a.727.727,0,0,1,.728.727v4.369a.728.728,0,0,1-.728.728h0a.728.728,0,0,1-.727-.728V400.7A.727.727,0,0,1,326.346,399.974Z",
    transform: "translate(-318.337 -399.974)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoCerrarSesion);
export default __webpack_public_path__ + "static/media/Icono-CerrarSesion.d652f64eb72687075ef60f7c283380e3.svg";
export { ForwardRef as ReactComponent };